module.exports = __webpack_public_path__ + "static/img/Sped-2020-72.32ea047.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Sped-2020-72.png
// module id = rMPl
// module chunks = 0